import { useContext, useMemo } from "react"
import { useErrorBanner } from "../../context/errorBanner/useErrorBanner"
import { ErrorHandlerContext } from "../../context/errorHandler/ErrorHandlerContext"
import type { ErrorMessage } from "../../types/ErrorMessage"

export type ErrorNotificationType = "inline" | "global" | "none"

type ErrorNotificationCallback = (error: ErrorMessage | undefined) => void

export const useErrorNotificationCallback = (
	notificationType: ErrorNotificationType,
): ErrorNotificationCallback | undefined => {
	const errorHandlerContext = useContext(ErrorHandlerContext)
	const errorBannerContext = useErrorBanner()

	if (!errorHandlerContext && notificationType === "inline") {
		throw new Error(
			"You are calling useBff or useBffDynamic outside an ErrorHandlerContext. " +
				"Make sure to wrap your Container using withErrorHandler and use <ErrorNotificationInline /> to display potential Network errors.",
		)
	}

	const setErrorInline = errorHandlerContext?.setError
	const setErrorGlobal = errorBannerContext.showError

	return useMemo(() => {
		switch (notificationType) {
			case "inline":
				return setErrorInline
			case "global":
				return setErrorGlobal
			case "none":
				return undefined
		}
	}, [notificationType, setErrorInline, setErrorGlobal])
}
